import React from 'react';
import { CurrentProfile } from './types';

const CurrentProfileContext = React.createContext<Partial<CurrentProfile>>({});

export default CurrentProfileContext;
